export default new class {
  constructor() { }

  matches(el, selector) {
    let names = [
      "matches",
      "matchesSelector",
      "mozMatchesSelector",
      "msMatchesSelector",
      "oMatchesSelector",
      "webkitMatchesSelector"
    ], i;

    for (i = 0; i < names.length; i++) {
      if (names[i] in el) {
        return el[names[i]](selector);
      }
    }
    return false;
  }

  contains(wrapper, inner) {
    if ('contains' in wrapper) {
      return wrapper.contains(inner);
    }

    for (let layer = inner; layer && layer.nodeType === 1; layer = layer.parentNode) {
      if (layer === wrapper) {
        return true;
      }
    }

    return false;
  }

  closest(el, selector) {
    if ("closest" in el) {
      return el.closest(selector)
    }
    if (!document.documentElement.contains(el)) {
      return null;
    }
    do {
      if (this.matches(el, selector)) {
        return el;
      }
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  }

  byId(id) {
    return document.getElementById(id);
  }

  attr(el, attrs) {
    if (!attrs) {
      let ats = {}
      for (let i = 0; i < el.attributes.length; i++) {
        ats[el.attributes[i].nodeName] = el.attributes[i].nodeValue
      }
      return ats;
    } else {
      for (let name in attrs) {
        if (Object.prototype.hasOwnProperty.call(attrs, name)) {
          el.setAttributeNS(null, name, attrs[name]);
        }
      }
    }
  }

  assign(target, varArgs) { // .length of function is 2
    if (target == null) { // TypeError if undefined or null
      throw new TypeError('Cannot convert undefined or null to object')
    }

    var to = Object(target)

    for (var index = 1; index < arguments.length; index++) {
      var nextSource = arguments[index]

      if (nextSource != null) { // Skip over if undefined or null
        for (var nextKey in nextSource) {
          // Avoid bugs when hasOwnProperty is shadowed
          if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
            to[nextKey] = nextSource[nextKey]
          }
        }
      }
    }
    return to
  }

  omit(target, args) {
    let res = this.assign({}, target)

    for (let i = 0; i < args.length; i++) {
      if (args[i] in res) {
        delete res[args[i]]
      }
    }

    return res;
  }

  isEmpty(x) {
    if (!x) return true
    for (let k in x) {
      if (({}).hasOwnProperty.call(x, k)) {
        return false
      }
    }
    return true
  }

  chunkString(str, length) {
    length = Math.floor(length)
    let regWithWordBreak = new RegExp(`^.{1,${length}}\\b`, "g")
      , nameChunks = []
      , match = null
    for (
      nameChunks = [];
      str.length > 0;
      str = str.substring(nameChunks[nameChunks.length - 1].length)
    ) {
      match = str.match(regWithWordBreak)

      if (match) {
        nameChunks.push(match[0])
      } else {
        nameChunks.push(str.substr(0, length))
      }
    }

    return nameChunks
  }

  applyMatrix(matrix, { x, y }) {
    return ({
      x: x * matrix[0] + y * matrix[2] + matrix[4],
      y: x * matrix[1] + y * matrix[3] + matrix[5]
    })
  }

  unapplyMatrix(matrix, { x, y }) {
    // @ts-ignore
    let inverted = Snap.matrix(...matrix).invert()

    return this.applyMatrix([
      inverted.a,
      inverted.b,
      inverted.c,
      inverted.d,
      inverted.e,
      inverted.f,
    ], { x, y })
  }

  watch(obj, propList, onChange) {
    let name, value
    for (let i = 0; i < propList.length; i ++) {
      name = propList[i]
      value = obj[name]
      ;(function(name, value) {
        Object.defineProperty(obj, name, {
          get() {
            return obj["@" + name]
          },
          set(value) {
            let pre = obj["@" + name]
            obj["@" + name] = value
            onChange(name, pre, value)
          }
        })
      } (name, value))
      obj["@" + name] = value
      obj[name] = value
    }

  }

  hasClass(el, className) {
    return !!(el.getAttribute("class") || "").match(new RegExp(`(^|\\s)(${className})(?=$|\\s)`))
  }

  addClass(el, className) {
    el.setAttribute("class", el.className + " " + className)
  }

  removeClass(el, className) {
    el.setAttribute("class", el.className.replace(new RegExp(`(^|\\s)(${className})(?=$|\\s)`), ""))
  }

  getTextLen(s){
    let sum=0;
    if(s){
      let len=s.length;
      for (let i = 0; i < len; i++) {
        let code=s.charCodeAt(i);
        sum+=code<=127?1:2;
      }
      sum=sum * 7 +10;
    }
    return sum<100?100:sum;
  }
  isRectNode(n){
    return n && n.type !== 'start' && n.type !== 'end';
  }
}



// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/utils/index.js